module.exports = __webpack_public_path__ + "media/images/swifticons/weather-cloudy-comment-438e9293a3e8af9b861200752eb8e801.svg";